import GlobalPopupContainerCenter from "../../../components/globalPopup/GlobalPopupContainerCenter";
import useClickOutside from "../../../hook/useClickOutside";
import {
    ViewListingAmenitiesPopupWrapper,
    ViewListingAmenitiesPopupTitle,
    ViewListingAmenitiesPopupGrid,
    ViewListingAmenitiesListItem,
    ViewListingAmenitiesListItemIcon,
    ViewListingAmenitiesListItemText,
    ViewListingAmenitiesPopupCategoryTitle,
} from "../viewListingStyling";

const categoriesData = {
    suggestedAmenities: [
        { name: "Wifi", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Wifi.svg" },
        { name: "Aircon", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Aircon.svg" },
        { name: "Pool", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Pool.svg" },
        { name: "TV", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Television.svg" },
        { name: "Kitchen", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Kitchen.svg" },
        { name: "Toiletries", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Toiletries.svg" },
        { name: "Towels", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Towels.svg" },
        { name: "Bedding", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Bedding.svg" },
    ],
    parking: [
        { name: "Free parking", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg" },
        { name: "Paid parking", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg" },
        { name: "Street parking", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg" },
        { name: "Valet parking", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg" },
    ],
    indoors: [
        { name: "Washer", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Washer.svg" },
        { name: "Dryer", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Dryer.svg" },
        { name: "Desk", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Desk.svg" },
        { name: "Cutlery", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Cutlery.svg" },
        { name: "Pots and pans", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/pots+and+pans.svg" },
        { name: "Dishwasher", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Dishwasher.svg" },
        { name: "Heating", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Heating.svg" },
        { name: "Iron", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Iron.svg" },
        { name: "Hair dryer", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Hair+dryer.svg" },
        { name: "Safe", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Safe.svg" },
        { name: "BBQ", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/BBQ.svg" },
        { name: "Gym", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Gym.svg" },
        { name: "Lift", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Lift.svg" },
    ],
    safety: [
        { name: "Safety gate", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Safety+gate.svg" },
        { name: "Carbon monoxide detector", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Carbon+monoxide+detector.svg" },
        { name: "Deadbolt", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Deadbolt.svg" },
        { name: "Fire extinguisher", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Fire+extinguisher.svg" },
        { name: "First aid kit", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/First+aid+kit.svg" },
        { name: "Smoke detector", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Smoke+detector.svg" },
    ],
    accessibility: [
        { name: "Ceiling hoist", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Ceiling+hoist.svg" },
        { name: "Wide doorways", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Wide+doorways.svg" },
        { name: "Wheelchair access", src: "https://d292awxalydr86.cloudfront.net/Amenities+icons/Wheelchair+access.svg" },
    ],
};

const categoryTitles: { [key: string]: string } = {
    suggestedAmenities: "Featured amenities",
    parking: "Parking",
    indoors: "Indoors",
    safety: "Safety",
    accessibility: "Accessibility",
};

interface ViewListingAmenitiesPopupProps {
    amenities: string[];
    toggleSelected: () => void;
    selected: boolean;
}

export default function ViewListingAmenitiesPopup({ amenities, toggleSelected, selected }: ViewListingAmenitiesPopupProps) {
    const popupRef = useClickOutside(selected, toggleSelected);

    if (!selected) return null;

    // Filter amenities that exist in our categories
    const validAmenities = amenities.filter(amenity => 
        Object.values(categoriesData).some(category => 
            category.some(item => item.name === amenity)
        )
    );

    // Group amenities by category
    const groupedAmenities = Object.entries(categoriesData).reduce((acc, [categoryKey, categoryItems]) => {
        const categoryAmenities = validAmenities.filter(amenity => 
            categoryItems.some(item => item.name === amenity)
        );
        if (categoryAmenities.length > 0) {
            acc[categoryKey] = categoryAmenities;
        }
        return acc;
    }, {} as { [key: string]: string[] });

    return (
        <GlobalPopupContainerCenter
            ref={popupRef}
            desktopWidth="704px"
            height="fit-content"
            noContinueBtn
            closePopup={toggleSelected}
            style={{ borderRadius: 24 }}
        >
            <ViewListingAmenitiesPopupWrapper style={{ paddingBottom: "32px" }}>
                <ViewListingAmenitiesPopupTitle>What this place offers</ViewListingAmenitiesPopupTitle>
                {Object.entries(groupedAmenities).map(([categoryKey, categoryAmenities]) => (
                    <div key={categoryKey}>
                        <ViewListingAmenitiesPopupCategoryTitle>
                            {categoryTitles[categoryKey]}
                        </ViewListingAmenitiesPopupCategoryTitle>
                        <ViewListingAmenitiesPopupGrid>
                            {categoryAmenities.map((amenitie) => {
                                const category = Object.values(categoriesData).find(cat => 
                                    cat.some(item => item.name === amenitie)
                                );
                                const amenityItem = category?.find(item => item.name === amenitie);
                                return (
                                    <ViewListingAmenitiesListItem key={amenitie}>
                                        <ViewListingAmenitiesListItemIcon src={amenityItem?.src} alt={amenitie} />
                                        <ViewListingAmenitiesListItemText>{amenitie}</ViewListingAmenitiesListItemText>
                                    </ViewListingAmenitiesListItem>
                                );
                            })}
                        </ViewListingAmenitiesPopupGrid>
                    </div>
                ))}
            </ViewListingAmenitiesPopupWrapper>
        </GlobalPopupContainerCenter>
    );
} 